import { render, staticRenderFns } from "./EdifactDetails.vue?vue&type=template&id=e62a1d10"
import script from "./EdifactDetails.vue?vue&type=script&lang=js"
export * from "./EdifactDetails.vue?vue&type=script&lang=js"
import style0 from "./EdifactDetails.vue?vue&type=style&index=0&id=e62a1d10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports